import React, { Component } from 'react';
import StudentHomePage from '../pages/StudentHomePage';

class StudentHome extends Component {
  render() {
    return (
      <div className="content">
        <StudentHomePage />
      </div>
    );
  }
}

export default StudentHome;